import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ExpensesService } from '../../services/expenses.service';
import { IExpenses } from '../../interfaces/expenses/iexpenses';
import { map } from 'rxjs';
import { IFilterData, IFilterModel } from '../../models/filter-model';
import { IFilter } from '../../interfaces/ifilter';
import { Filter } from '../../models/filter';
import { ProfessionalService } from '../../services/professional.service';
import { IProfessional } from '../../interfaces/professional/iprofessional';
import { outputFilter } from '../../models/output-filter';

@Component({
  selector: 'split-filter-professional',
  templateUrl: './split-filter-professional.component.html',
  styleUrls: ['./split-filter-professional.component.scss']
})
export class SplitFilterProfessionalComponent {
  public data: IFilterData[] = [];

  @Input() field!: string;
  @Input() label!: string;
  @Input() key!: string;
  @Input() groupId!: string;
  @Input() filters: Array<outputFilter> = [];

  @Output() onFilterEvent: EventEmitter<IFilterModel> = new EventEmitter<IFilterModel>();

  private filter = new Filter();

  constructor(private professionalService: ProfessionalService) {

  }

  ngOnInit(): void {
    this.load();
  }

  load() {
    
    if(this.filters.length > 0) {

      this.filters.forEach(element => {
        this.filter.filter(element.field, element.value, element.operator);
      });

    }

    let filter = this.filter.order('name', 'ASC').convertFilterInQuery();
    this.professionalService.getAll(filter).pipe(
      map((professionals: IProfessional[]) => professionals.filter((item: any) => item.isActive == true)),
      map((professionals: IProfessional[]) => professionals.map(professional => ({ name: professional.name, id: professional.id as number } as IFilterData))),
    ).subscribe(
      (data: IFilterData[]) => {
        this.data = data;
      }
    )
  }

  onSearchDropdownChange($event: IFilter[]) {
    this.filter.setFilter($event[0].key as string, $event); 
    this.load();
  }


}
